// Runtime configuration helper
// This allows accessing config from window.ENV (runtime) or process.env (build-time fallback)

declare global {
  interface Window {
    ENV?: {
      REACT_APP_API_URL?: string;
      REACT_APP_RECAPTCHA_SITE_KEY?: string;
      REACT_APP_STRIPE_PUBLISHABLE_KEY?: string;
    };
  }
}

export const getConfig = (key: string, defaultValue: string = ''): string => {
  // Try runtime config first (from window.ENV)
  if (typeof window !== 'undefined' && window.ENV && (window.ENV as any)[key]) {
    return (window.ENV as any)[key];
  }
  
  // Fallback to build-time env variable
  if ((process.env as any)[key]) {
    return (process.env as any)[key];
  }
  
  // Return default value
  return defaultValue;
};

// Convenience exports for common config values
export const API_BASE_URL = getConfig('REACT_APP_API_URL', 'http://localhost:3001/api');
export const RECAPTCHA_SITE_KEY = getConfig('REACT_APP_RECAPTCHA_SITE_KEY', '');
export const STRIPE_PUBLISHABLE_KEY = getConfig('REACT_APP_STRIPE_PUBLISHABLE_KEY', '');
